import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#f1f1f1',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,
      md: 1200,
      mdl: 1600,  // New custom breakpoint
      lg: 1800,
      xl: 2400,
      fourk: 3400,
    },
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
    },
    h2: {
      fontSize: '2rem',
    },
    h3: {
      fontSize: '1.75rem',
    },
    h4: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1.25rem',
    },
    h6: {
      fontSize: '1.1rem',
    },
    subtitle1: {
      fontSize: '0.95rem',
    },
    subtitle2: {
      fontSize: '0.85rem',
    },
    body1: {
      fontSize: '0.9rem',
    },
    body2: {
      fontSize: '0.8rem',
    },
    button: {
      fontSize: '0.85rem',
      textTransform: 'none',
    },
    caption: {
      fontSize: '0.75rem',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f0f0f2',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          height: '24px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '0.85rem',
        },
        sizeLarge: {
          fontSize: '0.95rem',
        },
        sizeSmall: {
          fontSize: '0.75rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.1rem',
        },
      },
    }
  },
});

export default theme;